import { toJS } from 'mobx'
import { useEffect } from 'react'
import {
  DocumentDownloadStatus,
  PollSettings,
} from 'todistukset-ui/src/vtj/stores/document-status.store'
import { useStore } from 'todistukset-ui/src/vtj/stores/store.util'

export const useDocumentDownloadStatus = (
  todistusPyyntoId: number,
  pollSettings?: PollSettings
): DocumentDownloadStatus => {
  const {
    documentDownloadStatus: {
      documentDownloadStatuses,
      pollDocumentDownloadStatus,
    },
  } = useStore()

  const documentStatus = toJS(documentDownloadStatuses.get(todistusPyyntoId))

  useEffect(() => {
    const cancel = pollDocumentDownloadStatus(todistusPyyntoId, pollSettings)
    return () => {
      cancel()
    }
  }, [pollDocumentDownloadStatus, pollSettings, todistusPyyntoId])

  return (
    documentStatus ?? {
      todistusPyyntoId,
      isDownloadable: false,
      isPolling: true,
      pollingTimedOut: false,
    }
  )
}
